import { ChangeDetectionStrategy, Component, HostBinding, Signal, computed, effect, input } from '@angular/core';
import { CoreComponent } from '../core/core.component.js';

type LinkMode = 'router' | 'external' | 'anchorRoute';
type LinkStyle = 'default' | 'noUnderline';
type LinkDisplayStyle = 'block' | 'inline';

@Component({
    selector: 'lib-link',
    templateUrl: './link.component.html',
    styleUrls: ['link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LinkComponent extends CoreComponent {
	@HostBinding('style') override style = 'display: block';

	public readonly routerLink = input.required<string | undefined>();
	public readonly linkStyle = input<LinkStyle>('default');
	public readonly externalUrl = input<string>();
	public readonly anchorRoute = input<string>();
	public readonly displayStyle = input<LinkDisplayStyle>('block');

	public readonly linkMode: Signal<LinkMode> = computed<LinkMode>(() => {
		const anchorRoute = this.processedAnchorRoute();
		const externalUrl = this.externalUrl();

		if (anchorRoute) {
			return 'anchorRoute';
		}

		if (externalUrl) {
			return 'external';
		}

		return 'router';
	});

	public readonly processedAnchorRoute = computed<string | undefined>(() => {
		const anchorRoute = this.anchorRoute();

		if (!anchorRoute) {
			return undefined;
		}

		if (anchorRoute.startsWith('#')) {
			return anchorRoute;
		}

		return `#${anchorRoute}`;
	});

	public readonly processedRouterLink = computed<string | undefined>(() => {
		const routerLink = this.routerLink();

		if (!routerLink) {
			return undefined;
		}

		if (routerLink.startsWith('/')) {
			return routerLink;
		}

		return `/${routerLink}`;
	});

	constructor() {
		super();

		effect(() => {
			const displayStyle = this.displayStyle();

			if (displayStyle === 'block') {
				this.style = 'display: block';
			} else if (displayStyle === 'inline') {
				this.style = 'display: inline';
			}
		});
	}
}
